export const COMPANY_NAME = "BOSS Pacheco Court, LLC";
export const COMPANY_SHORT = "BOSS Pacheco Court";
export const COMPANY_INITIALS = "BPC";
export const COMPANY_ADDRESS_FULL = "1918 University Ave Ste 2A, Berkeley, California, US 94704-3263";
export const COMPANY_LOCATION = "Berkeley, CA";
export const COMPANY_REGION = "Alameda County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=1918%20University%20Ave%20Ste%202A%2C%20Berkeley%2C%20California%2C%20US%2094704-3263";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Profile", "value": "Business directory" },
  { "label": "Region", "value": "Alameda County" },
  { "label": "Location", "value": "Berkeley, CA" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "BOSS Pacheco Court, LLC" },
  { "label": "City / State", "value": "Berkeley, CA" },
  { "label": "Address", "value": "1918 University Ave Ste 2A, Berkeley, California, US 94704-3263" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Directory profile", "body": "A concise public record of the organization and its principal location." },
  { "icon": "✦", "title": "Public information", "body": "This page presents only basic organization and location details." },
  { "icon": "✿", "title": "Berkeley location", "body": "Located on University Avenue in Berkeley, California." },
  { "icon": "❍", "title": "Visit details", "body": "Use the map link below for directions to the listed address." },
];
